export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-volume-none-4a2124280cda93ce1bcb535f3ce018e4.svg";